import { Label, Popup, Tab } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledTab = styled(Tab)`
  overflow: auto;
  .secondary {
    width: max-content;
  }
`;

export const FiltersWrapper = styled.div`
display: flex;
align-items: baseline;
gap: 10;
flex-wrap: wrap;
`
export const StyledLabel = styled(Label)`
border-radius: 15px !important;
max-width: 260px;
`
export const CommentWrapper = styled.div`
position: relative;
display: flex;
align-items: center;
gap: 15px; 
 .loader {
  position: sticky !important;
  margin-bottom: -6px !important;
 }
`
export const FormWrapper = styled.div`
.form-container {
  margin: 0 auto;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: opacity 0.5s ease, height 0.5s ease;
}

.form-container.visible {
  opacity: 1;
  height: auto;
  overflow: visible;
}
`
export const DrawwerWrapper = styled.div`
 .drawer {
  height: 90vh !important;
 }
 .comments {
  overflow-y: auto;
  max-height: 50vh !important;
 }
 .content {
  overflow: hidden;
 }
`
export const StyledInfoPopUpIcon = styled(Popup)`
background: ${props => props.color} !important;
color: white !important;
border-radius: 10px !important;
max-height: 200px !important;
max-width: 200px !important;
 .content {  
    max-height: 200px !important;
    max-width: 200px !important;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;  
    overflow: hidden;
}
`